import React from "react";
import styled from "styled-components";
import { FlexSection, FlexContainer, FlexDiv } from "@/components/Atoms/Box";
import theme from "@/foundation/Theme";
import { Typography } from "@/foundation/Typography/V2";
import Image from "@/components/Atoms/Image";
import { ShadowBtn } from "../HeroSection";

function GetToKnowUs(props) {
  const { data = {}, width, handleScrollToSection } = props || {};
  return (
    <>
      <SectionWrap>
        <Container>
          <LHSSection>
            <TextWrapper>
              <Typography
                variant={"label3"}
                fontFamily={"var(--man-800)"}
                color={theme.colorsV2.shyft.purple_text}
                mb={"16px"}
              >
                {data?.about_us?.badge}
              </Typography>
              <Title
                variant={"heading2"}
                color={theme.colorsV2.primary.shade_900}
                mb={"16px"}
              >
                {data?.about_us?.title}
              </Title>
              <Typography
                variant={"paragraph1"}
                color={theme.colorsV2.gray.shade_700}
                mb={"40px"}
                dangerouslySetInnerHTML={{
                  __html: data?.about_us?.subtitle,
                }}
              />
              {data?.about_us?.cta_text && (
                <FlexDiv>
                  <ShadowBtn
                    bgColor={theme.colorsV2.shyft.purple_text}
                    fontFamily={"var(--man-700)"}
                    hoverColor={theme.colorsV2.shyft.purple_text}
                    variant={"primary1"}
                    minWidth={"186px"}
                    onClick={handleScrollToSection}
                  >
                    {data?.about_us?.cta_text}
                  </ShadowBtn>
                </FlexDiv>
              )}
            </TextWrapper>
          </LHSSection>
          {(data?.about_us?.image_mob || data?.about_us?.image) && (
            <RHSSection>
              <ImageWRapper>
                <Image
                  src={
                    width > 1279
                      ? data?.about_us?.image_mob
                      : data?.about_us?.image
                  }
                />
              </ImageWRapper>
            </RHSSection>
          )}
        </Container>
      </SectionWrap>
    </>
  );
}

export default GetToKnowUs;

const SectionWrap = styled(FlexSection)`
  background-color: ${theme.colorsV2.primary.shade_25};
  padding: 32px 0 80px;
  @media only screen and (max-width: 1279px) {
    padding: 40px 0;
  }
`;
const Container = styled(FlexContainer)`
  @media only screen and (max-width: 1279px) {
    flex-direction: column;
  }
`;
const LHSSection = styled(FlexDiv)`
  width: 100%;
  max-width: 50%;
  flex-direction: column;
  margin-right: 16px;
  justify-content: center;
  @media only screen and (max-width: 1279px) {
    max-width: 100%;
    margin-right: 0;
    order: 1;
  }
`;
const RHSSection = styled(LHSSection)`
  margin-right: 0px;
  flex: 1;
  @media only screen and (max-width: 1279px) {
    max-width: 608px;
    margin: 0 auto 16px;
    order: 0;
  }
`;
const TextWrapper = styled(FlexDiv)`
  flex-direction: column;
  padding: 32px;
  @media only screen and (max-width: 1279px) {
    padding: 8px;
  }
`;
const Title = styled(Typography)``;
const ImageWRapper = styled(FlexDiv)`
  padding: 48px 20px 16px;
  @media only screen and (max-width: 1279px) {
    padding: 0;
  }
`;
